export default __webpack_public_path__ + "static/media/Pulse Rate.41f03a00.svg";